import apiPublic from './api/apiPublic';

const storeCredentials = (data) => {
  localStorage.clear();
  localStorage.setItem('accessToken', data.accessToken);
  localStorage.setItem('refreshToken', data.refreshToken);
  localStorage.setItem('expiresIn', data.expiresIn);
};

export const logout = async () => {
  localStorage.clear();
};

export const login = async (email, password) => {
  const formData = new URLSearchParams(Object.entries({ email, password })).toString();
  const response = await apiPublic.post('/users/login', formData);

  if (response.status === 200) return storeCredentials(response.data);
  throw response.rejectException();
};

export const register = async (user) => apiPublic.post('/users/register', user).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const refreshToken = async () => {
  const response = await apiPublic.post('/users/refresh-token', { refreshToken: this.getRefreshToken() });

  if (response.status === 200) return storeCredentials(response.data);
  throw response.rejectException();
};

export const forgetPassword = async (email) => {
  const response = await apiPublic.get('/users/forget-password/'.concat(email));

  if (response.status === 200) return response.data;
  throw response.rejectException();
};

export const recoveryPassword = async (state) => {
  const response = await apiPublic.post('/users/recovery-password', state);

  if (response.status === 200) return response.data;
  throw response.rejectException();
};

export const getRefreshToken = () => localStorage.getItem('refreshToken');

export const getAccessToken = () => localStorage.getItem('accessToken');

export const hasToken = () => !!getAccessToken();

function parseJwt(token) {
  if (!token) return {};

  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('')
    .map((c) => (`%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)).join(''));

  return JSON.parse(jsonPayload);
}

export const getGroups = () => (localStorage.getItem('accessToken')
  ? parseJwt(localStorage.getItem('accessToken'))['cognito:groups'] : []);
